var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-consult-wrapper"},[_c('div',{staticClass:"mobile-consult-main"},[_c('div',{on:{"click":_vm.toBuy}},[_vm._v("点击购买")])]),_c('pcPayment',{attrs:{"payModal":_vm.payShow},on:{"payClose":function($event){_vm.payShow = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }